// extracted by mini-css-extract-plugin
export default {"submitBtn":"Add_submitBtn__TPSwU","resetBtn":"Add_resetBtn__E34L9"};